import React from "react";
import { finalProjectStatusTypes } from "../../../../../enums/finalProjectStatusTypes";
import { formatDate } from "../../../../../../shared/utils/utils";
import iconsList from "../../../../../../shared/components/ui/icons/iconsList";
import Icon from "../../../../../../shared/components/ui/icons/Icon";
import classes from "./CardStatus.module.css";

const CardStatus = ({ type, text, date }) => {

    const generateStatus = () => {
        switch (type) {
            case finalProjectStatusTypes.approved:
                return (
                    <div className={classes.approved}>
                        <Icon name={iconsList.approvedIcon} size="16px" className={classes.approvedIcon} />
                        <span>{text} {date ? ` ${formatDate(date)}` : ''}</span>
                    </div>
                )
            case finalProjectStatusTypes.processing:
                return (
                    <div className={classes.processing}>
                        <span>{text}</span>
                    </div>
                )
        }
    }

    return (
        generateStatus()
    )
};

export default CardStatus;

